var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isTest)?_c('div',{staticClass:"home"},[_c('div',{staticClass:"home__cover"}),_c('div',{staticClass:"home__buttons"},[_c('button',{staticClass:"main-button home__button",on:{"click":_vm.start}},[_vm._v("開始測驗")])])]):_c('InvestmentTest',{attrs:{"resultDefault":_vm.result},on:{"restart":_vm.restart}})
}
var staticRenderFns = []

export { render, staticRenderFns }